export default "__VITE_ASSET__36805fdd__"